
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-activity",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg","class":"feather feather-activity"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.734 3.62l18.1 18.1","stroke":"currentColor","stroke-width":"2"}}),_c('path',{attrs:{"d":"M16.698 16.175l-.032.03c-.96.883-1.748 1.814-2.362 2.793-.903 1.44-1.459 2.794-1.67 4.062h-1.21c-.211-1.248-.768-2.593-1.67-4.033-.902-1.459-2.19-2.812-3.86-4.06-1.65-1.248-3.302-2.045-4.954-2.39v-1.21c1.632-.385 3.197-1.095 4.695-2.132.817-.568 1.561-1.199 2.233-1.89l8.83 8.83zM12.634.94c.173.96.518 1.95 1.036 2.967a14.591 14.591 0 001.987 2.88 17.767 17.767 0 002.766 2.448c1.517 1.075 3.062 1.786 4.637 2.131v1.21c-1.056.211-2.15.643-3.284 1.296-.53.31-1.042.649-1.537 1.016L9.165 5.813c.092-.125.183-.251.272-.38C10.473 3.918 11.136 2.42 11.424.94h1.21z","fill":"currentColor"}})])
          )
        }
      }
    